import React, { useContext } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import { Container, Row } from "reactstrap";

import "./Auth.css";
import { routes } from "../../routes.js";
import { AuthContext } from "../../context/AuthContext";

const Auth = (props: any) => {

  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.body.classList.add("bg-default");
    return () => {
      document.body.classList.remove("bg-default");
    };
  }, []);
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
    if (mainContent.current) {
      //@ts-ignore
      mainContent.current.scrollTop = 0;
    }
  }, [location]);

  const getRoutes = (routes: any) => {
    return routes.map((prop: any, key: number) => {
      if (prop.layout === "/auth") {
        return (
          //@ts-ignore
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <div
        ref={mainContent}
        className="bg-gradient-info-custom-bottom d-flex align-items-center justify-content-center position-relative"
        style={{ minHeight: "100vh" }}
      >
        {/* topo só como “fundo”, sem ocupar altura */}
        <div
          className="bg-gradient-info-custom py-7 py-lg-8 position-absolute top-0 start-0 w-100"
          style={{ zIndex: 0 }}
        >
          <div className="ml-7 position-absolute hide-on-small-screen">
            {/* ... */}
          </div>
        </div>

        {/* conteúdo centralizado */}
        <Container className="position-relative" style={{ zIndex: 1 }}>
          <Row className="justify-content-center">
            <Routes>
              {getRoutes(routes)}
              <Route path="*" element={<Navigate to="/auth/login" replace />} />
            </Routes>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Auth;
